import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useChangePastPaperStatus = () => {
  return useMutation((data) => {
    return axiosPost("/api/cw/pastPaperStatusChange", data);
  });
};

export default useChangePastPaperStatus;
